/** Mídia: o que o web recebe de volta depois do upload. */
import { z } from "zod";
import { uuid } from "./common.js";

/** Metadados de midia devolvidos ao web apos o upload (docs/06). */
export const mediaInfo = z.object({
  id: uuid,
  kind: z.enum(["image", "video", "audio", "voice", "document", "sticker"]),
  mime: z.string(),
  size: z.number().int().nonnegative(),
  name: z.string(),
  /** URL assinada temporaria para pre-visualizacao. */
  previewUrl: z.string(),
});
export type MediaInfo = z.infer<typeof mediaInfo>;
